import { Box } from '@mui/system';
import { useSnapshot } from 'valtio';
import ProfileStore from '../../store/profiles';
import { IProfile } from '../../types/policy-profile-types';
import DetailField from '../DetailField/DetailField';

export interface IProfileDetailsProps {
  profileInContext: IProfile;
}
const ProfileDetails: React.FC<
  React.PropsWithChildren<IProfileDetailsProps>
> = ({ profileInContext }: IProfileDetailsProps) => {
  const { enabledPolicies, totalPolicies } = useSnapshot(ProfileStore);

  return (
    <Box
      minWidth='100%'
      display='flex'
      gap={2}
      flexWrap='wrap'
      pb={1}
      justifyContent='flex-start'>
      <DetailField name='Total Policies' value={totalPolicies} />
      <DetailField name='Policies Enabled' value={enabledPolicies} />
      <DetailField name='Profile Version' value={profileInContext.version} />
      <DetailField name='Modified By' value={profileInContext.modifiedBy} />
      <DetailField
        name='Last Modified'
        value={new Date(profileInContext.lastModified).toLocaleString()}
      />
    </Box>
  );
};

export default ProfileDetails;
